import { FormRule } from "../interfaces/FormRule.interface";
import { getValue } from "../../infinity-store/methods/getValue";
import { ruleValue } from "./ruleValue";
import { compare } from "../../infinity-util/methods/compare";
import { compareDate } from "../../infinity-util/methods/compareDate";

/**
 * [Impure] Run rule and return value.
 * @param config - Config object.
 * @param rule - Rule to run.
 */
export function ruleEngine(config: any, rule?: FormRule): any {
    if (!rule) return rule => ruleEngine(config, rule);
    if (!(rule instanceof Object)) return;
    const { store, reducers } = config;
    let { any, all, concat, reduce, not, equal, fallback } = rule;
    let result: boolean;
    if (rule.compareDate) result = compareDate.apply(null, rule.compareDate.map(val => ruleValue(store, val)));
    if (rule.compare) result = compare.apply(null, rule.compare.map(val => ruleValue(store, val)));
    if (any) result = any.reduce((result, subrule) => result || ruleEngine(config, subrule), false);
    if (all) result = all.reduce((result, subrule) => !result ? false : ruleEngine(config, subrule), true);
    if (concat) result = concat.reduce((joined, value) => joined + ruleValue(store, value), "");
    if (reduce) {
        let [itemsKey, reducerKey, initialValue] = reduce;
        let items = getValue(itemsKey, store, getValue("preset", store, {})[itemsKey]);
        let reducer = getValue(reducerKey, store, reducers[reducerKey]);
        if(!items || !reducer) return;
        result = items.reduce(reducer, initialValue);
    }
    if (not) result = !ruleEngine(config, not);
    if (equal){
        if(result || result === undefined) result = ruleValue(store, equal);
        else if (fallback !== undefined) result = ruleValue(store, fallback);
    }
    return result;
}
